(function () {

  'use strict';

  const SUPABASE_URL    = 'https://xoolcbbpnvdylcoorlqg.supabase.co';
  const PUBLISHABLE_KEY = 'sb_publishable_bjOrV5qp2n0PtuVFOSA_6g_3Micws2T';

  /* =========================================================
     SESSION / AUTH — unchanged
     ========================================================= */

  function getSession() {
    try {
      const key = Object.keys(localStorage).find(
        (k) => k.includes('sb-') && k.endsWith('-auth-token')
      );
      if (!key) return null;
      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.error('[Corevian Mark Read] Session error:', error);
      return null;
    }
  }

  function getAccessToken()   { return getSession()?.access_token || null; }
  function getCurrentUserId() { return getSession()?.user?.id     || null; }

  /* =========================================================
     SUPABASE REQUEST HELPERS — unchanged
     ========================================================= */

  async function restGet(path) {
    const accessToken = getAccessToken();
    if (!accessToken) throw new Error('No active Corevian University session was found.');
    const response = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
      method: 'GET',
      headers: {
        apikey:        PUBLISHABLE_KEY,
        Authorization: `Bearer ${accessToken}`
      }
    });
    const text = await response.text();
    let body = null;
    try { body = text ? JSON.parse(text) : null; } catch { body = text; }
    if (!response.ok) {
      throw new Error(body?.message || body?.details || body?.error || `Request failed with status ${response.status}`);
    }
    return body;
  }

  async function rpc(functionName, payload = {}) {
    const accessToken = getAccessToken();
    if (!accessToken) throw new Error('No active Corevian University session was found.');
    const response = await fetch(`${SUPABASE_URL}/rest/v1/rpc/${functionName}`, {
      method: 'POST',
      headers: {
        apikey:           PUBLISHABLE_KEY,
        Authorization:    `Bearer ${accessToken}`,
        'Content-Type':   'application/json'
      },
      body: JSON.stringify(payload)
    });
    const text = await response.text();
    let body = null;
    try { body = text ? JSON.parse(text) : null; } catch { body = text; }
    if (!response.ok) {
      throw new Error(body?.message || body?.details || body?.error || `Request failed with status ${response.status}`);
    }
    return body;
  }

  /* =========================================================
     STYLES — unchanged
     ========================================================= */

  function injectStyles() {
    if (document.getElementById('cvnMarkReadStyles')) return;
    const style = document.createElement('style');
    style.id = 'cvnMarkReadStyles';
    style.textContent = `
      #cvnMarkReadWrap {
        width: 100%;
        box-sizing: border-box;
        margin-top: 16px;
        padding: 20px;
        border: 1px solid rgba(25,181,176,.28);
        border-radius: 14px;
        background: rgba(25,181,176,.06);
        font-size: 15px;
      }
      #cvnMarkReadWrap p {
        margin: 0 0 16px !important;
        color: #b9c6d8 !important;
        font-size: 15px !important;
        font-weight: 400 !important;
        line-height: 1.6 !important;
        letter-spacing: normal !important;
      }
      #cvnMarkReadButton {
        appearance: none !important;
        -webkit-appearance: none !important;
        border: 1px solid #19B5B0 !important;
        background: #19B5B0 !important;
        color: #07101f !important;
        font-family: inherit !important;
        font-size: 14px !important;
        font-weight: 800 !important;
        line-height: 1.2 !important;
        padding: 12px 18px !important;
        min-height: 42px;
        min-width: 135px;
        border-radius: 9px !important;
        cursor: pointer;
      }
      #cvnMarkReadButton:hover   { filter: brightness(1.04); }
      #cvnMarkReadButton:disabled { opacity: .55; cursor: not-allowed; }
      #cvnMarkReadMessage {
        display: none;
        margin-top: 14px;
        padding: 11px 13px;
        border-radius: 8px;
        font-size: 14px;
        line-height: 1.5;
      }
      #cvnMarkReadMessage.success {
        display: block;
        background: rgba(25,181,176,.14);
        border: 1px solid rgba(25,181,176,.40);
        color: #cffffb;
      }
      #cvnMarkReadMessage.error {
        display: block;
        background: rgba(190,65,65,.13);
        border: 1px solid rgba(210,80,80,.45);
        color: #ffd2d2;
      }
    `;
    document.head.appendChild(style);
  }

  /* =========================================================
     FIX 1 — parseCurrentDocument()

     ORIGINAL regex: /([A-Z]{2,}-DOC-\d+)\s*[·•-]\s*VERSION\s+([0-9.]+)/i
     This only matched "-DOC-" codes, which Corevian never uses.
     Real codes are: CHL-POL-001, CHL-SOP-001, CHL-BBP-001, CHL-ECP-001.

     NEW regex matches any pattern of the form:
       LETTERS-LETTERS-DIGITS · VERSION NUMBER
     e.g. "CHL-POL-001 · VERSION 2.0"

     The detail view header is rendered by detailHtml() as:
       <div class="cvn-doc-code">CHL-POL-001 · VERSION 2.0</div>
     We read from the DOM element directly if available,
     and fall back to body text scan if needed.
     ========================================================= */

  function parseCurrentDocument() {
    // Preferred: read directly from the rendered code element
    const codeEl = document.querySelector(
      '.cvn-doc-detail .cvn-doc-code, #cvnDocumentTop .cvn-doc-code'
    );
    if (codeEl) {
      const text = (codeEl.textContent || '').trim();
      // Matches: "CHL-POL-001 · VERSION 2.0" or "CHL-SOP-012 · VERSION 1.0"
      const match = text.match(
        /^([A-Z]{2,}-[A-Z]{2,}-\d+)\s*[·•\-]\s*VERSION\s+([0-9][0-9A-Za-z.]*)/i
      );
      if (match) {
        return {
          documentCode:  match[1].trim().toUpperCase(),
          versionNumber: match[2].trim()
        };
      }
    }

    // Fallback: scan body text with the corrected broad pattern
    const bodyText = document.body.innerText || '';
    const match = bodyText.match(
      /([A-Z]{2,}-[A-Z]{2,}-\d+)\s*[·•\-]\s*VERSION\s+([0-9][0-9A-Za-z.]*)/i
    );
    if (!match) return null;
    return {
      documentCode:  match[1].trim().toUpperCase(),
      versionNumber: match[2].trim()
    };
  }

  /* =========================================================
     FIND CURRENT ASSIGNMENT — unchanged
     ========================================================= */

  async function getCurrentAssignment() {
    const current = parseCurrentDocument();
    const userId  = getCurrentUserId();
    if (!current || !userId) return null;

    const documents = await restGet(
      `controlled_documents?select=id&document_code=eq.${encodeURIComponent(current.documentCode)}&limit=1`
    );
    if (!Array.isArray(documents) || !documents.length) return null;

    const documentId = documents[0].id;
    const versions   = await restGet(
      `controlled_document_versions?select=id,acknowledgment_required,version_number,status&document_id=eq.${encodeURIComponent(documentId)}&version_number=eq.${encodeURIComponent(current.versionNumber)}&limit=1`
    );
    if (!Array.isArray(versions) || !versions.length) return null;

    const version = versions[0];

    // Mark as Read must never replace formal acknowledgment
    if (version.acknowledgment_required === true) return null;

    const assignments = await restGet(
      `document_assignments?select=id,status,completed_at&user_id=eq.${encodeURIComponent(userId)}&document_version_id=eq.${encodeURIComponent(version.id)}&limit=1`
    );
    if (!Array.isArray(assignments) || !assignments.length) return null;

    return {
      ...assignments[0],
      documentCode:  current.documentCode,
      versionNumber: current.versionNumber
    };
  }

  /* =========================================================
     MESSAGE — unchanged
     ========================================================= */

  function showMessage(message, type) {
    const element = document.getElementById('cvnMarkReadMessage');
    if (!element) return;
    element.className   = type;
    element.textContent = message;
  }

  /* =========================================================
     FIX 2 — findNoAcknowledgmentNotice()

     ORIGINAL: searched for the phrase
       'this assignment does not require an acknowledgment'
     This failed because:
       a) The rendered text says "formal acknowledgment" (word mismatch)
       b) The notice only renders when assignment exists — if the user
          arrives from the library the notice may not render at all.

     NEW APPROACH — three-tier detection, most reliable first:

     Tier 1: Look for data-mark-read-anchor attribute.
       The documents.js noAckRequiredBlock now includes this attribute
       so this file can find it without any text parsing.

     Tier 2: Look for .cvn-doc-notice elements near the document detail
       view that contain any variation of "does not require".
       This covers older versions of documents.js without the data attr.

     Tier 3: Fall back to the original text scan with broader matching.
     ========================================================= */

  function findNoAcknowledgmentNotice() {
    // Tier 1: reliable data attribute (requires documents.js FIXED version)
    const anchor = document.querySelector('[data-mark-read-anchor]');
    if (anchor) return anchor;

    // Tier 2: class-based detection near the document detail view
    const detail = document.querySelector('.cvn-doc-detail, #cvnDocumentTop');
    if (detail) {
      const notices = Array.from(detail.querySelectorAll('.cvn-doc-notice'));
      const match = notices.find(el => {
        const text = (el.textContent || '').toLowerCase();
        return text.includes('does not require') ||
               text.includes('no acknowledgment') ||
               text.includes('does not need');
      });
      if (match) return match;
    }

    // Tier 3: broad body text scan (fallback for any document viewer)
    const phrases = [
      'does not require an acknowledgment',
      'does not require a formal acknowledgment',
      'no acknowledgment required',
      'acknowledgment is not required'
    ];
    const candidates = Array.from(document.querySelectorAll('body *')).filter(el => {
      if (el.id === 'cvnMarkReadWrap' || el.closest('#cvnMarkReadWrap')) return false;
      const text = (el.textContent || '').trim().toLowerCase();
      return phrases.some(phrase => text.includes(phrase));
    });
    if (!candidates.length) return null;
    candidates.sort((a, b) =>
      (a.textContent || '').trim().length - (b.textContent || '').trim().length
    );
    return candidates[0];
  }

  /* =========================================================
     INSTALL MARK AS READ — unchanged logic, debounced observer
     ========================================================= */

  async function installMarkRead() {
    if (document.getElementById('cvnMarkReadWrap')) return true;

    const notice = findNoAcknowledgmentNotice();
    if (!notice) return false;

    let assignment;
    try {
      assignment = await getCurrentAssignment();
    } catch (error) {
      console.error('[Corevian Mark Read] Unable to resolve assignment:', error);
      return false;
    }
    if (!assignment) return false;

    if (String(assignment.status || '').toLowerCase() === 'completed') return false;

    const wrap = document.createElement('div');
    wrap.id = 'cvnMarkReadWrap';
    wrap.innerHTML = `
      <p>
        This controlled document does not require a formal acknowledgment.
        When you have finished reviewing it, record the reading as complete.
      </p>
      <button id="cvnMarkReadButton" type="button">Mark as Read</button>
      <div id="cvnMarkReadMessage"></div>
    `;

    notice.insertAdjacentElement('afterend', wrap);

    const button = document.getElementById('cvnMarkReadButton');
    if (!button) return false;

    button.addEventListener('click', async function () {
      button.disabled    = true;
      button.textContent = 'Recording...';
      try {
        const result = await rpc('complete_controlled_document_reading', {
          p_assignment_id: assignment.id
        });
        console.log('[Corevian Mark Read] Reading completed:', result);
        showMessage(
          `${assignment.documentCode} Version ${assignment.versionNumber} was marked as read successfully.`,
          'success'
        );
        button.textContent = 'Completed';
        setTimeout(() => { window.location.reload(); }, 1300);
      } catch (error) {
        console.error('[Corevian Mark Read] Completion failed:', error);
        showMessage(error.message || 'Unable to complete this reading.', 'error');
        button.disabled    = false;
        button.textContent = 'Mark as Read';
      }
    });

    return true;
  }

  /* =========================================================
     FIX 3 — Debounced MutationObserver

     ORIGINAL: observer fired installMarkRead() on every DOM mutation.
     Every tab switch, keystroke, or scroll caused a re-run.
     With debounce, rapid DOM changes coalesce into one check
     200ms after the last mutation — much cleaner.
     ========================================================= */

  function debounce(fn, ms) {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  function start() {
    injectStyles();
    installMarkRead();

    const observer = new MutationObserver(
      debounce(function () { installMarkRead(); }, 200)
    );
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

})();